
import ServiceKNJ from "../../services/ServiceKNJ";

export const KnCis = {

    data() {
        return {

            // Číselníky
            KnSeznam: {
                KnSeznamKU: null,
                KnSeznamObci: null,
                KnSeznamCastiObci: null,
                KnSeznamTypuStaveb: null,
                KnSeznamCislovaniParcel: null,
                KnSeznamZdrojuCislovaniZE: null,
                KnSeznamDruhuPozemku: null,
                KnSeznamTypuJednotek: null,
                KnSeznamVyuzitiJednotky: null,
                KnSeznamVyuzitiPozemku: null,
                KnSeznamVyuzitiStavby: null,
                KnSeznamTypuOS: null
            },

        };
    },



    computed: {

        // Seznam KU, který bere v úvahu vybranou obec
        KnSeznamKnSeznamKUObec: function () {
            if (this.VybObec) {
                return this.KnSeznam.KnSeznamKU.filter(item => item.kodObce == this.VybObec.kod);
            } else {
                return this.KnSeznam.KnSeznamKU
            }
        },

        // Seznam části obcí, který bere v úvahu vybranou obec
        KnSeznamKnSeznamCastiObciObec: function () {
            if (this.VybObec) {
                return this.KnSeznam.KnSeznamCastiObci.filter(item => item.obecKod == this.VybObec.kod);
            } else {
                return this.KnSeznam.KnSeznamCastiObci
            }
        },


    },



    methods: {

        // Načtení čísleníků
        KnSeznamInit: function () {
            // služba
            ServiceKNJ.Init(this.AppServiceurl.ServiceKNJ);

            // Načíst všechny číselníky
            for (let item in this.KnSeznam) {
                this.NactiSeznam(item)
            }
        },

        // Seznam Obec - filtr
        FiltrSeznamObec: function (item, queryText) {
            const textOne = item.kod.toLowerCase();
            const textTwo = item.nazev.toLowerCase();
            const searchText = queryText.toLowerCase();
            return (
                textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
            );
        },

        // Seznam Ku - filtr
        FiltrSeznamKu: function (item, queryText) {
            const textOne = item.kod.toLowerCase();
            const textTwo = item.nazev.toLowerCase();
            const searchText = queryText.toLowerCase();
            return (
                textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
            );
        },

        // Seznam části obcí - filtr
        FiltrSeznamCastiObci: function (item, queryText) {
            const textOne = item.kod.toLowerCase();
            const textTwo = item.nazev.toLowerCase();
            const searchText = queryText.toLowerCase();
            return (
                textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
            );
        },

        NactiSeznam: function (JmenoCis) {
            this.IsWorking = true;
            ServiceKNJ.KnSeznam(JmenoCis)
                .then((response) => {
                    this.KnSeznam[JmenoCis] = response.data;
                    this.IsWorking = false;


                    // Výchozí nastavení 
                    if (JmenoCis == 'KnSeznamTypuStaveb') {
                        this.NajdiStaTyp = this.KnSeznam.KnSeznamTypuStaveb.find(itemc =>
                            itemc.kod == '1');
                    }



                })
                .catch((error) => {
                    console.log(error);
                    this.KnSeznam[JmenoCis] = null;
                    this.IsWorking = false;
                    this.Alert_text = "Chyba, pravděpodobně nejste přihlášeni.";
                    this.Alert_view = true;
                })
                .then(function () {
                    // always executed
                });
        },



    },

    mounted() {


    },


}
